export var customImageLoader = function customImageLoader(_ref) {
  var src = _ref.src,
      width = _ref.width;
  return "".concat(src, "?w=").concat(width);
};